export type GoogleAddressResult = {
    address_components: Array<{ long_name: string; types: string[] }>;
};

export type AddressFields = {
    addressLine1: string;
    addressPostalNumber: string;
    addressCity: string;
    addressDistrict: string;
};

export function addressFromGoogle(result: GoogleAddressResult): AddressFields {
    function part(type: string): string {
        const component = result.address_components.find((candidate) =>
            candidate.types.includes(type)
        );
        return component ? component.long_name : '';
    }

    return {
        addressLine1: `${part('route')} ${part('street_number')}`.trim(),
        addressPostalNumber: part('postal_code'),
        addressCity: part('locality') || part('postal_town'),
        addressDistrict: part('sublocality_level_1')
    };
}
